import { addStudents, clearStudentAnswers, deleteTeacherSession, getStudents } from "../firebase/firebaseController";

export const SUBMIT_STUDENTS = "SUBMIT_STUDENTS";
export const SUBMIT_STUDENTS_ERROR = "SUBMIT_STUDENTS_ERROR";
export const SUBMIT_STUDENTS_SUCCESS = "SUBMIT_STUDENTS_SUCCESS";

//status
export const END_SESSION = "END_SESSION";
export const END_SESSION_SUCCESS = "END_SESSION_SUCCESS";

export const CLEAR_ANSWERS = "CLEAR_ANSWERS";
export const CLEAR_ANSWERS_SUCCESS = "CLEAR_ANSWERS_SUCCESS";

export const submitStudents = () => ({
    type: SUBMIT_STUDENTS
})

export const submitStudentsError = (error) => ({
    type: SUBMIT_STUDENTS_ERROR,
    payload: error
})

export const submitStudentsSuccess = (students) => ({
    type: SUBMIT_STUDENTS_SUCCESS,
    payload: students
})


export const attempSubmit = (teacherID, students, evt) => {
    return async function (dispatch, getState, args) {
        try {
            dispatch(submitStudents());
            await new Promise(resolve => setTimeout(resolve, 2000));
            await addStudents(teacherID, students);
            let studentsData = await getStudents(teacherID);
            studentsData.sort((a, b) => {
                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                return 0;
            })
            dispatch(submitStudentsSuccess(studentsData));
            evt();
        }
        catch (e) {
            console.log(e.message);
            dispatch(submitStudentsError(e.message));
        }
    }
}


export const endSession = () => ({
    type: END_SESSION
})
export const endSessionSuccess = () => ({
    type: END_SESSION_SUCCESS
})

export const sessionEnd = (teacherID,evt) => {
    return async function (dispatch, getState, args) {
        try {
            dispatch(endSession());
            await new Promise(resolve => setTimeout(resolve, 2000));
            await deleteTeacherSession(teacherID)
            dispatch(endSessionSuccess());
            evt();
        }
        catch (e) {
            console.log(e);
        }
    }
}



export const clearAnswers = () => ({
    type: CLEAR_ANSWERS
})
export const clearAnswersSuccess = () => ({
    type: CLEAR_ANSWERS_SUCCESS
})

export const clearAll = (teacherID,students)=>{
    return async function(dispatch, getState, args){
        dispatch(clearAnswers())
        await new Promise(resolve => setTimeout(resolve, 2000));
        await clearStudentAnswers(teacherID,students)
        dispatch(clearAnswersSuccess());
    }
}